import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Fetch } from '../../utils/Utils';
import './PhoneNumber.css';

const PhoneNumber = () => {
  const { t } = useTranslation();
  const [revealed, setRevealed] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const handleReveal = () => {
    setLoading(true);
    setError(false);
    Fetch(
      'api/account/phone-number',
      'get',
      null,
      (data) => {
        setPhoneNumber(data.phone_number);
        setRevealed(true);
        setLoading(false);
      },
      () => {
        setError(true);
        setLoading(false);
      }
    );
  };

  return (
    <div className="phone-number-page">
      <h2>{t("phone_number_title")}</h2>
      <p>{t("phone_number_description")}</p>

      {!revealed && (
        <button
          className="btn-reveal"
          onClick={handleReveal}
          disabled={loading}
        >
          {loading ? t("loading") : t("reveal_phone_number")}
        </button>
      )}

      {revealed && phoneNumber && (
        <div className="phone-number-display">
          <span className="phone-number-value">{phoneNumber}</span>
        </div>
      )}

      {error && (
        <p className="phone-number-error">{t("phone_number_error")}</p>
      )}
    </div>
  );
};

export default PhoneNumber;
